export enum Currency {
  USD = 'USD',
  RUB = 'RUB',
}
